import React from 'react';
import { NavLink } from 'react-router-dom';
import { Grid, Button, Table, Menu, Checkbox } from 'semantic-ui-react';

const UserDetail = ({ data }) => {
  return (
    <Grid>
      <Grid.Column width={16}>
        <Menu.Item as={NavLink} to="/dashboard/admin-conformites-add">
          <Button positive inverted content="  Ajouter une conformite" />
        </Menu.Item>
      </Grid.Column>

      <Grid.Column width={16}>
        <Table compact celled definition>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>Numero Fiche</Table.HeaderCell>
              <Table.HeaderCell>Responsable Processus</Table.HeaderCell>
              <Table.HeaderCell>Responsable Visa</Table.HeaderCell>
              <Table.HeaderCell>Emetteur</Table.HeaderCell>
              <Table.HeaderCell>Detection date</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {data &&
              data.listConformites.items &&
              data.listConformites.items.map(
                ({
                  numeroFiche,
                  responsableProcessus,
                  id,
                  responsableVisa,
                  emetteur,
                  dateDetection
                }) => (
                  <Table.Row key={id}>
                    <Table.Cell collapsing>
                      <Checkbox slider />
                    </Table.Cell>
                    <Table.Cell> {numeroFiche}</Table.Cell>
                    <Table.Cell> {responsableProcessus}</Table.Cell>
                    <Table.Cell> {responsableVisa}</Table.Cell>
                    <Table.Cell> {emetteur}</Table.Cell>
                    <Table.Cell> {dateDetection}</Table.Cell>
                    <Table.Cell>
                      <Button className="ui basic button" as={NavLink} to={`/dashboard/admin-conformites-edit/${id}`}>
                        <i className="green icon edit"> </i>
                      </Button>
                    </Table.Cell>
                    <Table.Cell>
                      <Button className="ui basic button" as={NavLink} to={`/dashboard/admin-conformites-delete/${id}`}>
                        <i className="red icon trash"></i>
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                )
              )}
          </Table.Body>
        </Table>
      </Grid.Column>
    </Grid>
  );
};

export default UserDetail;
